import React from "react";
import { ShieldCheck, Trophy } from "lucide-react";
import { aboutImage } from "../mock/mock";

export default function About() {
  return (
    <section id="about" className="border-b border-white/[0.06] relative overflow-hidden">
      <div className="absolute inset-0 radial-fade opacity-70" />
      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/3] shadow-2xl bg-[#0a0a0b]">
            <img
              src={aboutImage}
              alt="About Ortiz Truck & Landscaping"
              style={{ transform: "rotate(90deg) scale(1.35)" }}
              className="photo-crisp w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 left-5 chip bg-[#0a0a0b]/85 backdrop-blur rounded-xl px-4 py-3 flex items-center gap-3">
            <div className="font-display font-extrabold text-[26px] text-[#f4efe6] leading-none">
              100%
            </div>
            <div className="leading-tight">
              <div className="text-[12px] text-[#c8c5bc] font-semibold">
                Locally Owned
              </div>
              <div className="text-[10px] tracking-[0.22em] text-[#8a877f] uppercase">
                Magic Valley
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="section-label mb-4">Our Journey &amp; Ethos</div>
          <h2 className="section-heading text-[28px] sm:text-[34px] md:text-[42px] leading-[1.08]">
            About Ortiz Truck &amp; Landscaping
          </h2>
          <p className="mt-6 text-[14.5px] leading-relaxed text-[#b6b3ab]">
            Ortiz Truck &amp; Landscaping LLC is a locally owned business
            proudly serving the Magic Valley area with reliable hauling. We
            specialize in material delivery, demolition debris removal, and
            dump truck hauling.
          </p>
          <p className="mt-4 text-[14.5px] leading-relaxed text-[#b6b3ab]">
            We&apos;re equipped to handle residential and commercial projects
            of all sizes. We take pride in honest work, dependable service, and
            helping our customers get the job done right. We understand that
            whether it&apos;s gravel for a new driveway or pulling debris from a
            job site, you need someone who shows up on time and acts with
            integrity.
          </p>
          <p className="mt-4 text-[14.5px] leading-relaxed text-[#b6b3ab]">
            From home driveway renovations to light-commercial bulk excavation
            clearing, our heavy-duty trucking equipment and professional team
            ensure your materials arrive safely or get hauled off cleanly. Our
            values are simple: honest pricing, reliable dispatching, and
            excellent results.
          </p>

          <div className="mt-8 pt-8 border-t divider-soft grid sm:grid-cols-2 gap-6">
            <div className="flex gap-3">
              <div className="h-10 w-10 rounded-lg chip flex items-center justify-center shrink-0">
                <ShieldCheck size={17} className="text-[#c9b98a]" />
              </div>
              <div>
                <h4 className="font-display font-bold text-[15.5px] text-[#f4efe6]">
                  Licensed &amp; Insured
                </h4>
                <p className="text-[12.5px] text-[#8a877f] mt-1 leading-relaxed">
                  Every aggregate transit or demolition cleanup is fully
                  covered under comprehensive policies.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="h-10 w-10 rounded-lg chip flex items-center justify-center shrink-0">
                <Trophy size={17} className="text-[#c9b98a]" />
              </div>
              <div>
                <h4 className="font-display font-bold text-[15.5px] text-[#f4efe6]">
                  Magic Valley Specialists
                </h4>
                <p className="text-[12.5px] text-[#8a877f] mt-1 leading-relaxed">
                  Deeply familiar with local quarries, gravel grading formulas,
                  and environmental debris codes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
